export function formatPhoneNumber(number: string) {
  // Удаляем все, кроме цифр
  const cleaned = number.replace(/\D/g, '');

  // Проверяем, что номер состоит из 11 цифр (например, для России)
  if (cleaned.length === 11) {
    return `+${cleaned[0]} ${cleaned.slice(1, 4)} ${cleaned.slice(4, 7)} ${cleaned.slice(7, 11)}`;
  }

  return number; // Если формат не соответствует, возвращаем исходный номер
}
